const SHOP_NAME_TO_TYPE = {
  灵柚: 1,
  萧发: 2,
  誉腾: 3,
  甄昂: 4,
  杭傲: 5,
  众联: 8,
  成都: 8,
};

export function shopTypeFromName(shopName) {
  if (!shopName) {
    return 0;
  }
  return SHOP_NAME_TO_TYPE[String(shopName).trim()] || 0;
}

export function collectShopTypesFromPayOrderRow(row) {
  let typeSet = new Set();
  if (!row) {
    return typeSet;
  }
  if (row.shopType != null && row.shopType !== "") {
    let shopType = parseInt(row.shopType, 10);
    if (!isNaN(shopType) && shopType) {
      typeSet.add(shopType);
    }
  }
  if (!typeSet.size && row.shopName) {
    String(row.shopName)
      .split("、")
      .map(name => name.trim())
      .filter(Boolean)
      .forEach(name => {
        let shopType = shopTypeFromName(name);
        if (shopType) {
          typeSet.add(shopType);
        }
      });
  }
  return typeSet;
}
